module.exports = __webpack_public_path__ + "static/What-Level-Should-I-Sign-Up-For_11-23-c3148722c1cc0edd4e349700dd3df8f4.pdf";